import http from "@/http/aisea/axios";
import qs from "qs";

const resource = "/enterprises/crews/responsibilities";

export default {
  fetch() {
    return http.get(resource, {
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  fetchList(crewId) {
    return http.get(
      `/enterprises/manning/vessels/crews/${crewId}/responsibilities`,
      {
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
  },

  update(crewId, data) {
    return http.put(
      `/enterprises/manning/vessels/crews/${crewId}/responsibilities`,
      data,
      {
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
  },
};
